module.exports = __webpack_public_path__ + "img/placeholder-it.db32662d.jpg";